import * as Yup from 'yup';

import { seniorityOptions as defaultSeniorityOptions } from '../../../defaultFilters';

export const useSeniorityFilter = ({ setFilters }) => {
  const seniorityOptions = defaultSeniorityOptions;

  const formSchema = Yup.object().shape({
    seniorities: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.string().required(),
      }),
    ),
  });

  const onSubmit = ({ seniorities }) => {
    setFilters({ seniorities });
  };

  return {
    formSchema,
    onSubmit,
    seniorityOptions,
  };
};
